/**
 * @requires HBS
 */
(function() {
	/**
	 * @exports DKA.main
	 */
	let module = {};

	/**
	 * Global init code for the whole application
	 */
	module.init = () => {
		// module.setupTriggeredAnimationModule(); 
		console.log("hello from tour.js");
	};

	 

	// module.setupTriggeredAnimationModule = () => {
	// 	let videoModule = document.querySelector('.js-triggered-animation');

	// 	if(!videoModule) {
	// 		return;
	// 	}

	// 	let offset = (el) => {
	// 		var rect = el.getBoundingClientRect(),
	// 			scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
	// 			scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	// 		return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
	// 	};
	// 	let videoModuleTop = offset(videoModule).top;
	// 	let video = document.querySelector('.js-ta-video');
	// 	let mobileSrc = video.getAttribute('data-mobile-src');
	// 	let desktopSrc = video.getAttribute('data-desktop-src');
	// 	let ran = false;

	// 	let scrollFunc = () => {
	// 		let scrollPos = window.pageYOffset || document.documentElement.scrollTop;

	// 		//play video when the module is 30% in the viewport;
	// 		if(scrollPos > (videoModuleTop - (document.documentElement.clientHeight * 0.8)) && ran !== true ) {
	// 			console.log('got to initialization point');
	// 			if ( video ) {
	// 				video.pause();
	// 				video.currentTime = 0;
	// 				video.play();
	// 			}
	// 			ran = true;
	// 		}
	// 	};

	// 	window.addEventListener('scroll', scrollFunc);

	// 	let checkWidths = () => {
	// 		if (window.innerWidth < 580 && video.getAttribute('src') !== mobileSrc) {
	// 			video.setAttribute('src', mobileSrc);
	// 			video.pause();

	// 		} else if (window.innerWidth > 579 && video.getAttribute('src') !== desktopSrc) {
	// 			video.setAttribute('src', desktopSrc);
	// 			video.pause();
	// 		}
	// 	};

	// 	window.addEventListener('resize', () => {
	// 		checkWidths();
	// 	});

	// 	checkWidths();
	// };
 

	/**
	 * Initialize the app and run the bootstrapper
	 */
	 var docReady = (callback) => {
		// in case the document is already rendered
		if (document.readyState !== 'loading') {
			callback();
		} else if (document.addEventListener) {
			// modern browsers
			document.addEventListener('DOMContentLoaded', callback);
		} else {
			// IE <= 8
			document.attachEvent('onreadystatechange', () => {
				if (document.readyState === 'complete') callback();
			});
		}
	};



	docReady(() => {
		module.init();
		//HBS.initPage();
	});

	HBS.namespace('DKA.main', module);
}());